import React, { useMemo } from "react";
import { Checkbox, Radio, Tooltip } from "@material-ui/core";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import Button from "../../../DesignSystem/button";
import Input from "../../../DesignSystem/input";
import Textarea from "../../../DesignSystem/textarea";
import FormFieldBox from "../../../DesignSystem/formFieldBox";
import GreenCheckMark from "../../../../assets/images/right-green-check-mark.svg";
import InfoIcon from "../../../../assets/images/info-icon.svg";
import BlueCheckMark from "../../../../assets/images/ic-agreement.svg";
import DollarIcon from "../../../../assets/images/dollar.svg";
import CentIcon from "../../../../assets/images/cent.svg";
import { ArrayOfCharactersNotAllowedInNumericFloatField, YearDaysForCalculation } from "../../../../utils/appConstants";
import SwipeIcon from "../../../../assets/images/swipe-icon.svg";
import GroupIconGlobe from "../../../../assets/images/group-icon-globe.svg";
import GroupIconCloud from "../../../../assets/images/group-icon-cloud.svg";
import ElipsisText from "../../../DesignSystem/Table/Cells/ElipsisText";
import { currencyFormatter, getInfo, wrapButtonInTooltip } from "../../../../utils/methods";
import CheckboxIcon from "../../../../assets/images/checkbox-unchecked.svg";
import CheckboxCheckedIcon from "../../../../assets/images/checkbox-checked.svg";

interface PutUpForSaleFormProps {
  leftPending: any;
  rightPending: any;
  edit: boolean;
  selectedRowSale: any;
  serviceDescription: string;
  onContractSelected: boolean;
  onDemandSelected: boolean;
  onContractPrice: string;
  onDemandPrice: string;
  disabled: boolean;
  loading: boolean;
  type: string;
  aggrementAccepted: {
    on_contract: boolean;
    on_demand: boolean;
  };
  isDBPrice: {
    onDemand: boolean;
    onContract: boolean;
  };
  canSellOnDemand: boolean;
  onAggredTermsClick: (_: string) => void;
  handlePutupForSaleClick: () => void;
  handleServiceDescription: (e: any) => void;
  handleOnContractPriceChange: (e: any) => void;
  handleOnDemandPriceChange: (e: any) => void;
  handleOnContractSelected: (e: any) => void;
  handleOnDemandSelected: (e: any) => void;
  onClose: () => void;
  acceptAgreementBypass: (agreed?: boolean, type?: string) => void;
  linkImage: any;
}

const PutUpForSaleForm: React.FC<PutUpForSaleFormProps> = ({
  onClose,
  type,
  linkImage,
  leftPending,
  rightPending,
  edit,
  canSellOnDemand,
  acceptAgreementBypass,
  selectedRowSale,
  serviceDescription,
  onContractSelected,
  isDBPrice,
  onDemandSelected,
  onContractPrice,
  onDemandPrice,
  disabled,
  loading,
  handlePutupForSaleClick,
  handleServiceDescription,
  handleOnContractPriceChange,
  handleOnDemandPriceChange,
  handleOnContractSelected,
  handleOnDemandSelected,
  aggrementAccepted,
  onAggredTermsClick,
}) => {
  const onContractPerMinute = onContractPrice ? ((parseFloat(onContractPrice) * 100 * 12) / (YearDaysForCalculation * 24 * 60)).toFixed(2) : 0;
  const onDemandPerMonth = onDemandPrice ? ((parseFloat(onDemandPrice) / 100) * ((60 * 24 * YearDaysForCalculation) / 12)).toFixed(2) : 0;
  return (
    <div className="putup-forsale-form">
      <div className="add-group-root">
        <div className="title">
          <label>{edit ? "Edit Listing in MarketPlace" : "Sell Link in MarketPlace"}</label>
        </div>
        <div className="form">
          {/* <div className="port-name">
            <div className="nearend-port">
              <label><ElipsisText text={selectedRowSale?.nne_name} width="170px" /></label>
              <span><ElipsisText text={selectedRowSale?.nearend_port_description} width="170px" /></span>
              <span><ElipsisText text={selectedRowSale?.nearend_port_name} width="170px" /></span>
            </div>
            <span className="swipe-icon"><img src={SwipeIcon} alt="Swipe" data-testid="swipe-icon" /></span>
            <div className="farend-port">
              <label><ElipsisText text={selectedRowSale?.fne_name} width="170px" /></label>
              <span><ElipsisText text={selectedRowSale?.farend_port_description} width="170px" /></span>
              <span><ElipsisText text={selectedRowSale?.farend_port_name} width="170px" /></span>
            </div>
          </div> */}
          <FormFieldBox>
            <label>
              Service Description
              <span className="asterisk">*</span>
            </label>
            <Textarea value={serviceDescription} onChange={handleServiceDescription} className="group-description" name="bandwidth-description" />
          </FormFieldBox>
          <FormFieldBox>
            <label>Service Status</label>
            <div className="flex left">
              {linkImage}
              {((leftPending || rightPending) &&
                !edit &&
                wrapButtonInTooltip(
                  `This service is pending move to WaveXchange. It may be sold, but it will not be available for purchase until it is moved on WaveXchange.`,
                  <div className="flex left">
                    Pending:
                    {getInfo()}
                  </div>,
                  "bottom-end"
                )) ||
                ""}
            </div>
          </FormFieldBox>
          {/* ON DEMAND */}
          {canSellOnDemand && (
            <div className="price">
              <div className="price-box-main">
                <div className="left">
                  <Checkbox
                    classes={{
                      root: "radio",
                    }}
                    checked={!!((edit && isDBPrice.onDemand) || aggrementAccepted.on_demand)}
                    onChange={() => acceptAgreementBypass(!((edit && isDBPrice.onDemand) || aggrementAccepted.on_demand), "on_demand")}
                    icon={<img className="checked-icon" src={CheckboxIcon} alt="radio" />}
                    checkedIcon={<img className="checked-icon" src={CheckboxCheckedIcon} alt="radio" />}
                  />
                </div>
                <div className="right">
                  <label>On Demand</label>
                  <div>
                    <FormFieldBox className="form-box-price">
                      <label>
                        Price
                        <Tooltip
                          classes={{
                            tooltip: "tooltip",
                          }}
                          arrow
                          placement="right"
                          title="On Demand Services are priced Per Minute"
                        >
                          <img className="info-icon" src={InfoIcon} alt="radio" />
                        </Tooltip>
                      </label>
                      <div className="input-main">
                        <Input
                          variant="input-post-icon"
                          tooltipTitle="Cent"
                          type="number"
                          min={1}
                          icon={CentIcon}
                          name="price"
                          value={onDemandPrice}
                          onChange={handleOnDemandPriceChange}
                          onWheel={(e) => e.target.blur()}
                          className="price-on-contract"
                          onKeyDown={(e) => ArrayOfCharactersNotAllowedInNumericFloatField.includes(e.key) && e.preventDefault()}
                        />
                        <div className="info-text">
                          <span>Per Minute</span>
                        </div>
                      </div>
                      <label className="per-month-price">
                        <Tooltip
                          classes={{
                            tooltip: "tooltip",
                          }}
                          arrow
                          placement="left"
                          title="Price Per Month will vary depending on length of the calendar month"
                        >
                          <span>&cong;&nbsp;$</span>
                        </Tooltip>
                        {currencyFormatter(parseFloat(onDemandPerMonth.toString()))} Per Month
                      </label>
                    </FormFieldBox>
                  </div>
                </div>
              </div>
              <div className="agreement-info">
                <div className="left" />
                <p>
                  <span onClick={() => onAggredTermsClick("on_demand")}>Terms and Conditions</span>
                </p>
              </div>
            </div>
          )}
          {/* ON CONTRACT */}
          <div className="price">
            <div className="price-box-main">
              <div className="left">
                <Checkbox
                  classes={{
                    root: "radio",
                  }}
                  color="primary"
                  checked={!!((edit && isDBPrice.onContract) || aggrementAccepted.on_contract)}
                  onChange={() => acceptAgreementBypass(!((edit && isDBPrice.onContract) || aggrementAccepted.on_contract), "on_contract")}
                  icon={<img className="checked-icon" src={CheckboxIcon} alt="radio" />}
                  checkedIcon={<img className="checked-icon" src={CheckboxCheckedIcon} alt="radio" />}
                />
              </div>
              <div className="right">
                <label>On Contract</label>
                <div>
                  <FormFieldBox className="form-box-price">
                    <label>
                      Price
                      <Tooltip
                        classes={{
                          tooltip: "tooltip",
                        }}
                        arrow
                        placement="right"
                        title="Contract Services are priced Per Month"
                      >
                        <img className="info-icon" src={InfoIcon} alt="radio" />
                      </Tooltip>
                    </label>
                    <div className="input-main">
                      <Input
                        variant="input-pre-icon"
                        tooltipTitle="Dollar"
                        type="number"
                        min={1}
                        icon={DollarIcon}
                        name="price"
                        value={onContractPrice}
                        onChange={handleOnContractPriceChange}
                        className="price-on-contract"
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => ArrayOfCharactersNotAllowedInNumericFloatField.includes(e.key) && e.preventDefault()}
                      />
                      <div className="info-text">
                        <span>Per Month</span>
                        <span>(Calender)</span>
                      </div>
                    </div>
                    <span style={{ paddingTop: "5px" }}>24 Month Contract</span>
                    <label className="per-month-price">
                      <Tooltip
                        classes={{
                          tooltip: "tooltip",
                        }}
                        arrow
                        placement="left"
                        title="Price Per Minute will vary depending on length of the calendar month"
                      >
                        <span>&cong;&nbsp;</span>
                      </Tooltip>
                      {currencyFormatter(parseFloat(onContractPerMinute.toString()))}
                      <span className="cent">
                        <img src={CentIcon} alt="Cent" />
                      </span>{" "}
                      Per Minute
                    </label>
                  </FormFieldBox>
                </div>
              </div>
            </div>
            <div className="agreement-info">
              <div className="left" />
              <p>
                <span onClick={() => onAggredTermsClick("on_contract")}>Terms and Conditions</span>
              </p>
            </div>
          </div>
        </div>
        <div className="buttons">
          <Button variant="greyed" className="btn cancel-btn" text="Cancel" onClick={onClose} />
          <Button
            variant="primary"
            className="btn"
            text={edit ? "Save" : "Put up for Sale"}
            disabled={disabled}
            onClick={handlePutupForSaleClick}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default PutUpForSaleForm;
